import React from 'react';
import { useNavigate } from 'react-router-dom';

const FaydaError = () => {
  const navigate = useNavigate();

  const handleRetry = () => {
    navigate('/verify'); // Redirects back to your verification initialization route
  };

  const handleSupport = () => {
    navigate('/myAccount'); // Optional: Redirects to help/support page
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-8 text-center shadow-xl transition-all">
        
        {/* Error/Alert Icon */}
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-red-100 mb-6 animate-pulse">
          <svg
            className="h-10 w-10 text-red-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            ></path>
          </svg>
        </div>

        {/* Title */}
        <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
          Verification Failed
        </h2>

        {/* Description */}
        <p className="mt-4 text-sm text-gray-500 leading-relaxed">
          We couldn't complete your <span className="font-semibold text-gray-700">Fayda</span> digital identity verification. This could be due to a timeout, mismatched details, or a network issue.
        </p>

        {/* Divider */}
        <hr className="my-6 border-gray-200" />

        {/* Action Buttons */}
        <div className="flex flex-col gap-3">
          <button
            onClick={handleRetry}
            className="inline-flex w-full justify-center rounded-xl bg-green-600 px-4 py-3 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600 transition-all duration-200"
          >
            Try Again
          </button>
          
          <button
            onClick={handleSupport}
            className="inline-flex w-full justify-center rounded-xl bg-transparent border border-gray-300 px-4 py-3 text-sm font-semibold text-gray-700 hover:bg-gray-50 transition-all duration-200"
          >
            Go Back
          </button>
        </div>
        
      </div>
    </div>
  );
};

export default FaydaError;